<template>
  <div class="sample-item">
    <el-form label-position="right" label-width="168px" :model="form" :rules="rules" ref="form">
      <div class="sample-title" v-if="isOiq"><span>{{form.row}}#</span> {{form.sampleName}}</div>
      <div class="ind-sample-title" v-else>{{index + 1}}#</div>
      <el-row :gutter="47">
        <el-col :span="12" v-for="item2 in form.sampleFromDTOList" :key="item2.sampleKey">
          <el-form-item :label="item2.sampleKeyName" :prop="item2.sampleKey" :rules="getRules(item2, form)" v-if="getShow(item2)" :class="`${item2.isMust ? 'is-required' : ''} itemType${item2.type} ${item2.remarkEnums?'has-append': ''}`">
            <el-input placeholder="" v-model="form[item2.sampleKey]" :disabled="disabledAll" :maxlength="item2.fillLen">
              <template slot="append" v-if="item2.remarkEnums && item2.remarkEnums.length">
                <el-select v-model="form[item2.sampleKey + 'PageRemark']" placeholder="请选择" :disabled="disabledAll">
                  <el-option
                    v-for="item in item2.remarkEnums"
                    :key="item.value"
                    :label="item.enumName"
                    :value="item.enumCode">
                  </el-option>
                </el-select>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "SampleItem",
  props: {
    disabledAll: {
      type: Boolean,
      default: false
    },
    isOiq: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    reportLuaCode: {
      type: String,
      default: ''
    },
    sampleItem: {
      type: Object,
      default: null
    },
    commonProps: {
      type: Object,
      default() {
        return {}
      }
    },
    required: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      form: {},
      rules: {}
    }
  },
  watch: {
    sampleItem: {
      handler(val) {
        if (val) this.form = val
      },
      immediate: true
    },
  },
  methods: {
    getRules(data, item) {
      const arr = []
      if (data.isMust) {
        arr.push(this.required)
      }
      if (this.reportLuaCode !== 'ZN' && this.reportLuaCode !== 'EN') {
        const validate = (rule, value, callback) => {
          if (this.commonProps.isSave && !value && item.sampleFromGoup[data.sampleGroup].some(v => v !== data.sampleKey && item[v])) {
            return callback(new Error('必填项'));
          } else {
            return callback()
          }
        }
        arr.push({ validator: validate })
      }
      if (data.regexRule) {
        arr.push({ pattern: new RegExp(data.regexRule), message: data.showAttr.regErrTips || '格式错误' })
      }
      return arr
    },
    getShow(data) {
      return data.lua === 'CHI' && this.reportLuaCode !== 'EN' || data.lua === 'EN' && this.reportLuaCode !== 'ZN'
    },
    getValidate() {
      const sample = JSON.parse(JSON.stringify(this.form))
      sample.sampleFromDTOList.forEach(item => {
        item.sampleValue = ''
        item.remark = ''
        if (this.getShow(item)) {
          item.sampleValue = sample[item.sampleKey]
          item.remark = sample[item.sampleKey + 'PageRemark']
        }
      })
      return {
        sample,
        validator: new Promise(resolve => this.$refs.form.validate(resolve))
      }
    },
  }
}
</script>

<style scoped lang="scss">
.sample-item {
  background: #F5F5F5;
  margin-bottom: 16px;
  padding: 15px 148px 6px 0;
  position: relative;
  .ind-sample-title {
    color: rgb(255, 102, 0);
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    position: absolute;
    top: 28px;
    left: 25px;
  }
  .sample-title {
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    padding: 4px 25px 15px;
    span {
      color: #FF6600;
    }
  }
  .add-sample, .del-sample {
    font-size: 14px;
    color: #CA4300;
    padding: 10.5px 0;
    img {
      vertical-align: text-top;
      margin-right: 10px;
    }
  }
  .del-sample {
    color: #878787;
    margin-top: 15px;
    img {
      margin-right: 12px;
    }
  }
  .itemType0 {
    &.has-append {
      ::v-deep .el-input .el-input__inner {
        border-right: 0;
      }
    }
    &.is-error {
      ::v-deep .el-input-group__append {
        border-color: #F56C6C;
      }
    }
    ::v-deep .el-input-group__append {
      padding: 0;
      width: 62px;
      background: #fff;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        height: 20px;
        width: 1px;
        background: #D2D2D2;
        left: 0;
        top: 9px;
      }
      .el-select {
        width: 100%;
        margin: 0;
        .el-input__inner {
          height: 38px;
          line-height: 36px;
          padding-right: 15px;
          padding-left: 9px;
        }
        .el-input__suffix {
          width: auto;
        }
      }
    }
  }
}
</style>